<div class="strpt-stats">
	<div class="sts-wrap" [ngStyle]="themeVars">
		<div class="sts-icon-badge">
			<i class="material-icons">map</i>
		</div>
		<div class="sts-header">
			<div class="sts-title-group">
				<span class="sts-title">Territory Sales Stats</span>
			</div>

			<div class="d-flex align-items-center strpt-stats__header-actions">
				<div class="strpt-stats__period mr-2" *ngIf="stats?.datefrom && stats?.dateto">
					<span class="strpt-stats__period-current">
						{{ stats.datefrom | date:'MMM d' }} &ndash; {{ stats.dateto | date:'MMM d' }}
					</span>
					<span class="strpt-stats__period-prev" *ngIf="stats.prevfrom && stats.prevto">
						vs {{ stats.prevfrom | date:'MMM d' }} &ndash; {{ stats.prevto | date:'MMM d' }}
					</span>
					<span class="strpt-stats__period-pct" *ngIf="stats.mtdPct !== null && stats.mtdPct !== undefined" [ngClass]="pctClass">
						<i class="fa" [ngClass]="pctIcon"></i>
						{{ stats.mtdPct | number:'1.1-1' }}% vs LY
					</span>
				</div>
				<button
					type="button"
					class="sts-icon-btn"
					(click)="reload()"
					[disabled]="loading"
					matTooltip="Refresh"
					[matTooltipPosition]="'below'">
					<i class="material-icons">refresh</i>
				</button>
			</div>
		</div>

		<div class="strpt-stats__toolbar">
			<label class="strpt-stats__month-field">
				<span>Primary month</span>
				<input type="month" name="strptPrimaryYm" [(ngModel)]="kpiPrimaryYm" [disabled]="loading" />
			</label>
			<label class="strpt-stats__month-field">
				<span>Compare to</span>
				<input type="month" name="strptCompareYm" [(ngModel)]="kpiCompareYm" [disabled]="loading" />
			</label>
			<button
				type="button"
				class="strpt-stats__months-btn"
				(click)="applyCustomMonths()"
				[disabled]="loading || !kpiPrimaryYm || !kpiCompareYm">
				Apply months
			</button>
			<button
				type="button"
				class="strpt-stats__months-btn strpt-stats__months-btn--quiet"
				(click)="resetToRollingMtd()"
				[disabled]="loading"
				matTooltip="This month vs same span last month (rolling MTD)"
				[matTooltipPosition]="'below'">
				Rolling MTD
			</button>
		</div>

		<div class="strpt-stats__body">
			<div class="strpt-stats__loading" *ngIf="loading">
				<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
					<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
				</svg>
			</div>

			<ng-container *ngIf="!loading && stats">
				<p class="strpt-stats__headline">
					{{ stats.mtdSales | currency }}
				</p>

				<div class="strpt-stats__rows">
					<div class="strpt-stats__row">
						<span class="strpt-stats__label"><i class="material-icons">people</i> Active Customers</span>
						<span class="strpt-stats__value">
							{{ stats.activeCustomers | number:'1.0-0' }}
							<span class="strpt-stats__delta" [ngClass]="customerDeltaClass()" *ngIf="stats.activeCustomersLY !== undefined">
								<ng-container *ngIf="customerDelta() > 0">+</ng-container>{{ customerDelta() | number:'1.0-0' }} vs LY
							</span>
						</span>
					</div>

					<div class="strpt-stats__row" *ngIf="stats.topTerritory">
						<span class="strpt-stats__label"><i class="material-icons">place</i> Top Territory</span>
						<span class="strpt-stats__value">
							{{ stats.topTerritory.territory_name }}
							<span class="strpt-stats__sub">{{ stats.topTerritory.sales | currency }}</span>
						</span>
					</div>

					<div class="strpt-stats__row" *ngIf="stats.topBrand">
						<span class="strpt-stats__label"><i class="material-icons">label</i> Top Brand</span>
						<span class="strpt-stats__value">
							{{ stats.topBrand.name }}
							<span class="strpt-stats__sub">{{ stats.topBrand.sales | currency }}</span>
						</span>
					</div>
				</div>

				<div class="strpt-stats__chart" *ngIf="stats.byTerritory?.length">
					<div class="strpt-stats__chart-title">Sales by Territory</div>
					<div class="strpt-stats__bar">
						<div
							class="strpt-stats__bar-segment"
							*ngFor="let t of stats.byTerritory; let i = index"
							[style.width.%]="t.pct_of_total"
							[ngClass]="'strpt-stats__bar-segment--' + (i % 6)"
							[matTooltip]="t.territory_name + ': ' + (t.sales | currency) + ' (' + (t.pct_of_total | number:'1.1-1') + '%)'"
							[matTooltipPosition]="'above'">
						</div>
					</div>
					<ul class="strpt-stats__legend">
						<li *ngFor="let t of stats.byTerritory; let i = index">
							<span class="strpt-stats__swatch" [ngClass]="'strpt-stats__bar-segment--' + (i % 6)"></span>
							<span class="strpt-stats__legend-name">{{ t.territory_name }}</span>
							<span class="strpt-stats__legend-pct">{{ t.pct_of_total | number:'1.1-1' }}%</span>
						</li>
					</ul>
				</div>
			</ng-container>

			<div class="strpt-stats__empty" *ngIf="!loading && !stats && error">
				<p class="text-muted text-center m-0">{{ error }}</p>
			</div>
		</div>

		<div class="strpt-stats__footer">
			<button type="button" class="strpt-stats__link-btn" (click)="openFullReport()">
				<i class="material-icons">visibility</i> View full report
			</button>
		</div>
	</div>
</div>
